import { useState } from 'react';
import { TestimonialsFormTypes } from 'src/routes/TestimonialsForm/types';

export type UseTestimonialsFormTypes = ReturnType<
  typeof useTestimonialsFormTypes
>;

export const useTestimonialsFormTypes = () => {
  const [formTypes, setFormTypes] = useState<TestimonialsFormTypes>(
    TestimonialsFormTypes.init,
  );

  return {
    formTypes,
    setFormTypes,
  };
};
